import "../../css/global.scss";
import "./login.scss";

// Load Firebase First
import firebase from 'firebase/compat/app';

// Load Components
import { getAuthObject } from "../../data-access/FirebaseAuthV8.js";
import NavBar from "../../components/NavBar.js";
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import User from "../../shared/classes/User.js";
import { setupNavBar } from "../utils/setup.js";
import { initializeNewCustomer} from "../../data-access/UserServices.js";
import { TERMS_SERVICE_URL, GETTING_STARTED_URL, DASHBOARD_URL, 
    PRIVACY_POLICY_URL } from "../../shared/constants/urls.js";

/**
 * Initializes a new User object in Firestore for the given Firebase Auth user, then updates its id token based on its newly-created custom claims.
 * @param {firebase.auth.User} user - The Firebase Auth user object for the new user, not to be confused with our internal User object. 
 */
async function initializeNewUser(user) {
    // Create a new User in Firestore.
    await initializeNewCustomer();
    // Refresh the user's id token with the most up-to-date custom claims (e.g. so they have PERMISSIONS.User).
    await user.getIdTokenResult(true);
    window.location.replace(GETTING_STARTED_URL);
}

/**
 * Callback function that will be called by FirebaseUI when a user has
 * successfully signed in. We use this callback to create a document
 * for the user in the "users" collection. DO NOT attempt to make this
 * function an async function using awaits. It will not work.
 * @param {firebaseui.auth.AuthResult} authResult
 * @param {string} redirectUrl
 * @returns {boolean}
 */
function successfulSignInCallback(authResult, redirectUrl) {
    // Callback is only called if user successfully signs in.

    // IF this is the user's first sign-in, we want to create a document 
    // in the database for the user.
    let user = authResult.user
    if (authResult.additionalUserInfo.isNewUser) {
        document.querySelector("#info").innerText = "Setting up your user account!";
        initializeNewUser(user);
        /* Return true automatically redirects user with the link provided
        * in signInSuccessUrl. Because the async functions are not supported, 
        * we must return false to let firebaseUI know not to automatically reroute
        * us. We must manually reroute ourselves.
        */
        return false;
    }

    return true;
}

//==================================================
// Code that must be added to each page that will utilize the
// NavBav web component.
let navbarElem = document.querySelector("nav-bar");
setupNavBar(navbarElem);
// End of Navbar related setup code.
//====================================================


async function onLoad() {

    // Two Versions of this page 
    // 1) 'make-account'
    // 2) 'sign-in'
    let params = new URLSearchParams(window.location.search);
    let state = params.get("state");
    let makeAccount = (state == 'make-account');

    let title = makeAccount ? "Sign up for Glamis911.com" : "Sign in to Glamis911.com"
    document.querySelector("#page-title").innerHTML = title;
    
    let auth = await getAuthObject();

    // FirebaseUI config.
    let uiConfig = {
        signInSuccessUrl: DASHBOARD_URL,
        signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            {
                provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
                fullLabel: makeAccount ? "Sign up with email" : "Sign in with email"
            },
            {
                provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                fullLabel: makeAccount ? "Sign up with Google" : "Sign in with Google"
            }
            
            // firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
            signInSuccessWithAuthResult: successfulSignInCallback,
        },
        // tosUrl and privacyPolicyUrl accept either url string or a callback
        // function.
        // Terms of service url/callback.
        tosUrl: TERMS_SERVICE_URL,
        // Privacy policy url/callback.
        privacyPolicyUrl: PRIVACY_POLICY_URL
    };

    if (process.env.NODE_ENV !== "production") {
        console.log(`Build process set to development mode, so defaulting to auth emulator`);
        auth.useEmulator("http://localhost:9099");
    }
    

    // Initialize the FirebaseUI Widget using Firebase.
    var ui = new firebaseui.auth.AuthUI(auth);
    // The start method will wait until the DOM is loaded.
    ui.start('#firebaseui-auth-container', uiConfig);

    // Modal callbacks
    
}
onLoad();




